<template>
    <div class="scene-item-wrap" v-show="data.length > 0">
        <div class="scene-title">{{ sceneTitle }}</div>
        <div class="scene-box" v-show="defaultShow">
            <div ref="sceneBox" class="single-col">
                <el-tooltip
                    :disabled="item.id == 'all'"
                    v-for="item in sceneData"
                    :key="item.id"
                    class="scene-name"
                    :class="{ 'scene-active': currentId == item.id }"
                    placement="bottom"
                >
                    <div slot="content">
                        {{ satisfaction }}: {{ item.satisfaction ? item.satisfaction : "0.00%" }} <br />
                        {{ evaNum }}: {{ item.evaNum ? item.evaNum : 0 }}
                    </div>
                    <el-button @click="sceneClick(item)">{{ item.label }}</el-button>
                </el-tooltip>
            </div>
            <span class="more-scene" v-show="showHideStyle" @click="moreClick">{{ moreScene }}</span>
        </div>
        <div class="scene-box show-all-scene" v-show="!defaultShow">
            <el-tooltip
                :disabled="item.id == 'all'"
                v-for="item in sceneData"
                :key="item.id"
                class="scene-name"
                :class="{ 'scene-active': currentId == item.id }"
                placement="bottom"
            >
                <div slot="content">
                    {{ satisfaction }}: {{ item.satisfaction ? item.satisfaction : "0.00%" }} <br />
                    {{ evaNum }}: {{ item.evaNum ? item.evaNum : 0 }}
                </div>
                <el-button @click="sceneClick(item)">{{ item.label }}</el-button>
            </el-tooltip>
            <span class="more-scene" @click="packUpClick">{{ packUp }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "SceneItem",
    props: ["data", "level"],
    data() {
        return {
            currentId: "all",
            lineHight: "",
            defaultShow: true,
            sceneTitle: ""
        };
    },
    watch: {
        level: {
            handler(val) {
                let title = this.levelTitle;
                this.sceneTitle = title[val];
            },
            immediate: true
        },
        data() {
            this.currentId = "all";
            this.$nextTick(() => {
                this.lineHight = this.$refs.sceneBox.scrollHeight;
            });
        },
        levelTitle: {
            handler(title) {
                this.sceneTitle = title[this.level];
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        levelTitle() {
            return {
                "1": this.$t("zhiji.hotSpot.firstScene"),
                "2": this.$t("zhiji.hotSpot.secondScene"),
                "3": this.$t("zhiji.hotSpot.thirdSceneTitle")
            };
        },
        satisfaction() {
            return this.$t("zhiji.satisfaction.satisfaction");
        },
        evaNum() {
            return this.$t("zhiji.satisfaction.evaNum");
        },
        allLabel() {
            return this.$t("zhiji.hotSpot.all");
        },
        packUp() {
            return this.$t("zhiji.hotSpot.packUp");
        },
        moreScene() {
            return this.$t("zhiji.hotSpot.moreScene");
        },
        showHideStyle() {
            if (this.lineHight > 40) {
                return true;
            } else {
                return false;
            }
        },
        sceneData() {
            let initData = [
                {
                    label: this.allLabel,
                    id: "all",
                    level: this.level
                }
            ];
            return this.data && initData.concat(this.data);
        }
    },
    methods: {
        sceneClick(data) {
            this.currentId = data.id;
            this.$emit("sceneClick", {
                item: data,
                level: data.level
            });
        },
        moreClick() {
            this.defaultShow = false;
        },
        packUpClick() {
            this.defaultShow = true;
        }
    }
};
</script>

<style lang="scss" scoped>
.scene-item-wrap {
    margin-bottom: 16px;

    .scene-title {
        padding-bottom: 4px;
        font-weight: bold;
    }

    .scene-box {
        display: flex;

        .single-col {
            height: 35px;
            overflow: hidden;
            position: relative;
        }

        .more-scene {
            border-radius: 4px;
            margin: 6px 5px 0 0;
            cursor: pointer;
            font-weight: bold;
            margin-left: 6px;
            padding: 4px 0 5px;
            border: none;
            background: #fff;
            color: #2ec2ff;
            width: 220px;
        }

        .scene-name {
            display: inline-block;
            padding: 0 16px 0;
            border-width: 1px 1px 1px 1px;
            border-style: solid;
            border-color: #d8e4f0;
            border-radius: 4px;
            margin: 0 8px 8px 0;
            box-sizing: border-box;
            cursor: pointer;

            &:hover {
                border-color: #4cadf2;
                color: #fff;
                background: #4cadf2;
            }
        }

        .pack-up-scene {
            display: inline-block;
            font-weight: bold;
            margin-left: 6px;
            padding: 4px 0 5px;
            border: none;
            border-radius: 4px;
            margin: 0 5px 8px 0;
            cursor: pointer;
        }

        .scene-active {
            border-color: #4cadf2;
            color: #fff;
            background: #4cadf2;
        }
    }

    .show-all-scene {
        height: inherit;
        display: inline-block;
    }
}
</style>
